import BossModel from "@/models/BossModel";

export default class Topic extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-blog/topic';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteBlogTopics';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
		}
	}

    static relations() {
        return {}
    }

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api()
            .limit(0)
            .get(true);
    }

}
